import { render } from "./NavbarBody.vue?vue&type=template&id=99065fa0&scoped=true"
import script from "./NavbarBody.vue?vue&type=script&lang=js"
export * from "./NavbarBody.vue?vue&type=script&lang=js"

import "./NavbarBody.vue?vue&type=style&index=0&id=99065fa0&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99065fa0"]])

export default __exports__